import { Box, SxProps, Theme } from '@mui/material';
import { FormattedNumber } from 'shared/controls';

const containerStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
};

type NumberTextFieldProps = {
  currentValue?: string | number;
  diffingValue?: string | number;
  suffix?: string;
  prefix?: string;
  percent?: boolean;
  decimalScale?: number;
  fixedDecimalScale?: boolean;
};

export function NumberCompareTextField({
  currentValue,
  diffingValue,
  suffix,
  prefix,
  percent = false,
  decimalScale,
  fixedDecimalScale,
}: NumberTextFieldProps) {
  if (percent) {
    suffix = '%';
  }
  const currentFieldValue = percent ? Number(currentValue) * 100 : Number(currentValue);
  const diffingFieldValue = diffingValue && percent ? Number(diffingValue) * 100 : diffingValue;
  const isValuesSame = currentFieldValue === diffingFieldValue;

  return isValuesSame && currentValue !== undefined ? (
    <FormattedNumber
      value={currentFieldValue}
      suffix={suffix}
      prefix={prefix}
      fixedDecimalScale={fixedDecimalScale}
      decimalScale={decimalScale}
    />
  ) : (
    <Box sx={containerStyles}>
      {diffingValue !== undefined && (
        <FormattedNumber
          style={{ textDecoration: 'line-through' }}
          value={diffingFieldValue}
          suffix={suffix}
          prefix={prefix}
          fixedDecimalScale={fixedDecimalScale}
          decimalScale={decimalScale}
        />
      )}
      {currentValue !== undefined && (
        <FormattedNumber
          value={currentFieldValue}
          suffix={suffix}
          prefix={prefix}
          fixedDecimalScale={fixedDecimalScale}
          decimalScale={decimalScale}
        />
      )}
    </Box>
  );
}
